module.exports = __webpack_public_path__ + "img/very-good.60ae32ce.svg";